export default __webpack_public_path__ + "static/media/customer.bc5dcd84.svg";